import { AuthenticationData } from '../store/authentication';
import { apiClient } from './apiClient';

export interface ComplementaryConsolidation {
    internalId: string;
    creditorName: string;
    accountNumber?: string;
    kidNumber?: string;
}

export const complementaryConsolidationService = async (
    proxyBaseUrl: string,
    apiKey: string,
    arn: string | undefined,
    authenticationData: AuthenticationData,
    complementaryConsolidations: ComplementaryConsolidation[],
): Promise<void> => {
    await apiClient<void>(`${proxyBaseUrl}/consolidation/${arn}`, {
        method: 'PATCH',
        body: { complementaryConsolidations },
        apiKey,
        authenticationData,
        responseType: 'void',
        sentryTag: 'complementary_consolidation',
        sentryExtra: { arn },
    });
};
